import auth from './auth';
import gateway from './gateway';
import partnerConfig from './partner-config';
import reportingApi from './reporting-api';
import batchPrintApi from './batch-print-api';
import userProfile from './user-profile';
import reportRequestStatusApi from './report-request-status-api';

export default {
    auth,
    gateway,
    partnerConfig,
    reportingApi,
    batchPrintApi,
    userProfile,
    reportRequestStatusApi,
};
